// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"86f3b617","48":"49128f40","130":"97db11a6","368":"5a87517c","605":"dd62d034"}[chunkId] + ".chunk.css";
};